"use strict";

var decodeState = function decodeState(encodedString) {
  try {
    return JSON.parse(window.atob(encodedString));
  } catch (e) {
    console.error(e);
    return {};
  }
};
module.exports = {
  decodeState: decodeState
};